import React from 'react';

import Button from '../../UI/Button/Button';
import FlexModal from '../../UI/FlexModal/FlexModal';

import classes from './SuccessDialog.module.css';

import closeIconBlack from '../../../assets/icons/icon-close-black.png';
import tickIconGreen from '../../../assets/icons/icon-success-dialog-green.png';

const successDialog = (props) => {
    return (
        <FlexModal visible={props.show}>
            <div className={classes.SuccessDialog}>
                <img
                    className={classes.CloseIcon}
                    src={closeIconBlack}
                    alt="Close Icon"
                    onClick={props.buttonClicked}
                />
                {/* <img
                    className={classes.GreenTick}
                    alt="Tick Icon"
                    src={tickIconGreen} /> */}
                <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 50 50" width="80" height="80">
                    <g>
                        <circle className={classes.Circle} cx="25" cy="25" r="24" />
                        <polyline id="line" className={classes.Line} points="13.5,24.5 21.5,32.5 37.5,16.5" />
                    </g>
                </svg>
                <h3 className={classes.SuccessText}>Success</h3>
                <h4 className={classes.SuccessMessage}>{props.message}</h4>

                <div className={classes.ButtonContainer}>
                    <Button
                        styleclass={"NonMobileOnly"}
                        label={props.buttonLabel}
                        clicked={props.buttonClicked}
                        margin="0px"
                        padding="8px 48px"
                    />
                    <Button
                        styleclass={"MobileOnly"}
                        label={props.buttonLabel}
                        clicked={props.buttonClicked}
                        margin="0px"
                        padding="1em 2em"
                        fontSize="0.625em"
                    />
                </div>
            </div>
        </FlexModal>
    );
}

export default successDialog;